/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SbRespNegotiable_item$ref = any;
type SbRespProminentTileDescription_item$ref = any;
type SbRespTradeSourcingBanner_searchBrowse$ref = any;
type SbSharedItemTrackingProvider_searchBrowse$ref = any;
type SbSharedMeasurementUnitProvider_searchBrowse$ref = any;
type SharedItemTile_item$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbRespSearchResultContainer_searchBrowse$ref: FragmentReference;
export type SbRespSearchResultContainer_searchBrowse = {|
  +displayUriRef: ?string,
  +edges: ?$ReadOnlyArray<?{|
    +node: ?{|
      +serviceId: ?string,
      +$fragmentRefs: SbRespProminentTileDescription_item$ref & SharedItemTile_item$ref & SbRespNegotiable_item$ref,
    |}
  |}>,
  +$fragmentRefs: SbSharedMeasurementUnitProvider_searchBrowse$ref & SbSharedItemTrackingProvider_searchBrowse$ref & SbRespTradeSourcingBanner_searchBrowse$ref,
  +$refType: SbRespSearchResultContainer_searchBrowse$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbRespSearchResultContainer_searchBrowse",
  "type": "SearchBrowseQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedMeasurementUnitProvider_searchBrowse",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedItemTrackingProvider_searchBrowse",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespTradeSourcingBanner_searchBrowse",
      "args": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "displayUriRef",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "SearchBrowseQueryEdge",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "Item",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "serviceId",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "FragmentSpread",
              "name": "SbRespProminentTileDescription_item",
              "args": null
            },
            {
              "kind": "FragmentSpread",
              "name": "SharedItemTile_item",
              "args": null
            },
            {
              "kind": "FragmentSpread",
              "name": "SbRespNegotiable_item",
              "args": null
            }
          ]
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '636b328ab44b547ac0491946da59f147';
module.exports = node;
